import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useNavigate } from "react-router-dom";
import styles from "./style";
import CustomPagination from "../../../../../components/CustomPagination";
import { ReactComponent as Edit } from "../../../../../assets/images/edit.svg";
import Modal from "../../../../../components/Modal";

const SupplierList = ({ data, page, setPage, total, handleDelete }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState();
  const navigate = useNavigate();

  const deleteData = (item) => {
    setValue(item);
  }
  const handleDeleteItem = () => {
    handleDelete(value);
    setOpen(false);
  };

  const handleEditNavigate = (item) => {
    navigate("/dashboard/editSupplier", { state: { item } })
  }

  const handleViewNavigate = (item) => {
    navigate("/dashboard/supplierDetails", { state: { item } })
  }

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Supplier</TableCell>
              <TableCell sx={styles.TableHead}>Phone</TableCell>
              <TableCell sx={styles.TableHead}>Payable</TableCell>
              <TableCell sx={styles.TableHead}>Paid</TableCell>
              <TableCell sx={styles.TableHead}>Due</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src="" sx={{ mr: "8px" }} />
                    <Box >
                      <Typography sx={styles.name}>{item?.name}</Typography>
                      <Typography sx={styles.mail}>{item?.email}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.phone}</TableCell>
                  <TableCell sx={styles.tabledata}>${(item?.payable || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={styles.tabledata}>${(item?.amountPaid || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={styles.tabledata}>${(item?.amountDue || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
                      <Edit onClick={() => { handleEditNavigate(item) }} sx={{ cursor: 'pointer' }} />
                      <RemoveRedEyeOutlinedIcon onClick={() => handleViewNavigate(item)} sx={{ ...styles.viewIcon, cursor: 'pointer' }} />
                      <DeleteOutlineIcon sx={{ color: '#878787', cursor: 'pointer' }} onClick={() => {
                        deleteData(item?._id), setOpen(true);
                      }} />
                    </Box>
                  </TableCell>
                </TableRow>
              )))}
          </TableBody>
        </Table>
        {data &&
          <CustomPagination
            pageCount={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={data.length}
          />}
      </TableContainer>
      <Modal open={open} setOpen={setOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Suppliers"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>);
};

export default SupplierList;
